import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { RiCustomerService2Fill } from 'react-icons/ri';

const HelpSupport = () => {
  return (
    <div className="flex w-full justify-center mt-8 px-4 max-w-4xl">
      
        <div className="w-full bg-white shadow-md rounded-lg px-8 pt-6  pb-8 mb-4 max-w-6xl">
          <div className='flex flex-row space-x-3'>
          <RiCustomerService2Fill size={26} />
          <h2 className="text-2xl font-bold mb-4">
          
          Help & Support</h2>
          </div>
        
      <div className="bg-white pt-4 rounded-lg">
        <p className="text-gray-700 mb-6">
          To get in touch with us, you have several convenient options:
        </p>
        <ul className="space-y-4">
          <li className="flex items-center space-x-2">
            <FaWhatsapp size={24} color="green" />
            <span>
              <strong>WhatsApp:</strong>{' '}
              <a 
                href={`https://wa.me/916374480026?text=Hi`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 underline"
              >
                Send us a message
              </a>
            </span>
          </li>
          <li className="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-blue-500 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
            <span>
              <strong>Email:</strong> Reach out to us at{' '}
              <a
                href="mailto:contact@shvesa.com"
                className="text-blue-500 underline"
              >
                contact@shvesa.com
              </a>
            </span>
          </li>
          <li className="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-red-500 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
              />
            </svg>
            <span>
              <strong>Live Chat:</strong> Click the chat window on our website
              to instantly connect with one of our friendly representatives who
              is standing by ready to assist you.{' '}
              <a href="www.shvesa.com" className="text-blue-500 underline">
                Click here
              </a>
            </span>
          </li>
        </ul>
        <p className="text-gray-700 mt-6">
          We look forward to hearing from you and providing the help you need!
        </p>
      </div>
      </div>
      </div>
  );
};

export default HelpSupport;